var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata, __param } from "tslib";
import { Logger } from '@patsnap/tahiti-core/common/logger';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SpacesModel } from '../model/spaces-model';
import { PaginatedSpacesRepository } from './paginated-spaces-repository.interface';
import { GetSpaceQueryService } from './space-query-service.interface';
import { Emitter } from '@patsnap/tahiti-core/common/event';
import { Disposable } from '@patsnap/tahiti-core/common/disposable';
import { SpaceLabelsService } from '@/domains/space-labels/services/space-labels-service.interface';
import { UserInfoService } from '@/domains/user/services/user-info-service.interface';
let InfiniteSpacesServiceImpl = class InfiniteSpacesServiceImpl {
    constructor(_spacesModel, _getSpaceQueryService, _paginatedSpacesRepository, _logger, _userInfoService, _spaceLabelsService) {
        this._spacesModel = _spacesModel;
        this._getSpaceQueryService = _getSpaceQueryService;
        this._paginatedSpacesRepository = _paginatedSpacesRepository;
        this._logger = _logger;
        this._userInfoService = _userInfoService;
        this._spaceLabelsService = _spaceLabelsService;
        this.emitter = new Emitter();
        this.onStatesChange = this.emitter.event;
        this._currentPage = 0;
        this._pageSize = 10;
        this._total = -1;
        this._totalPage = -1;
        this._loading = false;
    }
    get fulfilled() {
        return this._spacesModel.modelData.length === this._total;
    }
    dispose() {
        this._currentPage = 0;
        this._pageSize = 10;
        this._total = -1;
        this._totalPage = -1;
        this._loading = false;
    }
    get currentPage() {
        return this._currentPage;
    }
    get loading() {
        return this._loading;
    }
    get hasMore() {
        return this._totalPage > 1;
    }
    fetch() {
        this._spacesModel.dispose();
        this._currentPage = 1;
        const spaceQuery = this._getSpaceQueryService.getSpaceQuery();
        const options = {
            page: this._currentPage,
            pageSize: this._pageSize,
            sortBy: spaceQuery.sortBy,
            spaceType: spaceQuery.spaceType,
            labelName: spaceQuery.labelName,
        };
        return this._query(options);
    }
    fetchNextPage() {
        let spaces;
        let dispose = Disposable.NULL;
        if (this.fulfilled) {
            this._logger.warn('No more data to fetch');
            spaces = Promise.resolve([]);
        }
        else if (this._loading) {
            this._logger.warn('Already fetching data');
            spaces = Promise.resolve([]);
        }
        else if (this._currentPage >= this._totalPage) {
            this._logger.warn('No more data to fetch');
            spaces = Promise.resolve([]);
        }
        else {
            const page = this._currentPage + 1;
            const spaceQuery = this._getSpaceQueryService.getSpaceQuery();
            const options = {
                page: page,
                pageSize: this._pageSize,
                sortBy: spaceQuery.sortBy,
                spaceType: spaceQuery.spaceType,
                labelName: spaceQuery.labelName,
            };
            const result = this._query(options);
            dispose = result.dispose;
            this._currentPage = page;
        }
        return {
            spaces,
            dispose,
        };
    }
    _query(options) {
        this._setLoading(true);
        let _disposed = false;
        const dispose = Disposable.create(() => {
            _disposed = true;
        });
        const spaces = this._paginatedSpacesRepository.query(options)
            .then((result) => {
            if (!_disposed) {
                this._spacesModel.update((spaces) => [...spaces, ...result.data]);
                this._total = result.totalWithoutFilter;
                this._totalPage = result.totalPage;
                this._userInfoService.refreshUserInfoSpaceDataCount();
            }
            this._setLoading(false);
            return result.data;
        })
            .catch(() => {
            this._setLoading(false);
            return [];
        });
        /* 下面的代码必须放在 this._paginatedSpacesRepository.query 下面，因为要合并请求 */
        this._spaceLabelsService.querySpaceLabels();
        return {
            spaces,
            dispose,
        };
    }
    _setLoading(bool) {
        this._loading = bool;
        this.emitter.fire({
            isLoading: bool,
            fulfilled: this.fulfilled,
            hasMore: this.hasMore,
        });
    }
};
InfiniteSpacesServiceImpl = __decorate([
    injectable(),
    __param(0, inject(SpacesModel)),
    __param(1, inject(GetSpaceQueryService)),
    __param(2, inject(PaginatedSpacesRepository)),
    __param(3, inject(Logger)),
    __param(4, inject(UserInfoService)),
    __param(5, inject(SpaceLabelsService)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpacesModel !== "undefined" && SpacesModel) === "function" ? _a : Object, typeof (_b = typeof GetSpaceQueryService !== "undefined" && GetSpaceQueryService) === "function" ? _b : Object, typeof (_c = typeof PaginatedSpacesRepository !== "undefined" && PaginatedSpacesRepository) === "function" ? _c : Object, typeof (_d = typeof Logger !== "undefined" && Logger) === "function" ? _d : Object, typeof (_e = typeof UserInfoService !== "undefined" && UserInfoService) === "function" ? _e : Object, typeof (_f = typeof SpaceLabelsService !== "undefined" && SpaceLabelsService) === "function" ? _f : Object])
], InfiniteSpacesServiceImpl);
export { InfiniteSpacesServiceImpl };
